export const iconFontAwesomeGamingGhost = (
	<i className="fa-solid fa-ghost"></i>
);
